import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaDataTable from "../../../components/MeaDataTable";
import trainingsAPI from "../../../services/trainings";
import MeaLink from "../../../components/MeaLink";
import { PERMISSION_SCHOOL_TRAININGS } from "../../../permissions";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";

const TrainingsListComponent = forwardRef((props, ref) => {
  const { showAddButton, redirectPath = "classes" } = props;
  const { auth, currentMembership, hasPermission } = useAuthContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const schoolId = currentMembership?.school_id;
  const accessToken = auth?.access_token;
  //
  //
  const [state, setState] = useUrlState({
    trainingName: "",
    trainingStatus: "OPEN",
  });
  const [training, setTraining] = useState(null);
  const navigate = useNavigate();
  //
  const queryList = trainingsAPI.useGetList(
    schoolId,
    accessToken,
    page,
    pageSize,
    state.trainingStatus
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  useEffect(() => {
    if (queryList?.data?.data?.length === 1) {
      navigate(`/school/${schoolId}/secretariat/${redirectPath}/${queryList?.data?.data[0]?.id}`, { replace: true });
    }
  }, [queryList?.data, redirectPath, schoolId, navigate]);
  //
  return (
    <>
      <MeaDataTable
        query={queryList}
        serviceAPI={trainingsAPI}
        names={{
          pagination: "trainings",
          singular: "formation",
          plural: "formations",
        }}
        showDeleteButton={false}
        setPage={setPage}
        setPageSize={setPageSize}
        schoolId={schoolId}
      >
        <Column
          field="name"
          header="Formation"
          body={(item) => (
            <MeaLink to={"/school/" + schoolId + "/secretariat/" + redirectPath + "/" + item.id} permission={PERMISSION_SCHOOL_TRAININGS.GET}>
              {item.name}
            </MeaLink>
          )}
        ></Column>
      </MeaDataTable>
    </>
  );
});

export default TrainingsListComponent;
